export default "__VITE_ASSET__b3020fc4__"